// ** Import from react dom
import { Route, Routes, Navigate, useLocation } from "react-router-dom";

// ** Import core SCSS styles
import "assets/scss/theme.scss";

// ** Import Layouts
import DashboardIndex from "layouts/dashboard/DashboardIndex";
import AuthLayout from "layouts/dashboard/AuthLayout";
import PdfViewer from "components/courses/viewcourse/components/PdfViewer"; // Capitalization must match

// ** Import Dahbaord Menu Pages
import Overview from "components/dashboard/overview/Overview";
import Analytics from "components/dashboard/analytics/Analytics";
// ** Import Courses Pages
import AllCourses from "components/courses/allcourses";

// ** Import Authentication components
import SignIn from "components/authentication/SignIn";
import AddOrg from "components/organisation/addNewOrg";
import AllOrg from "components/organisation/allorg";
import ConfigOrg from "components/organisation/ConfigOrganization";
import OrgSingle from "components/organisation/vieworg";
import Addnewcoures from "components/courses/add-new-course/addcourse";
import AddUser from "components/users/add-new-user";
// import ViewCourse from "components/courses/viewcourse/ViewCourse";
import AddNewCoordinator from "components/organisation/addNewCoordinator";
import CourseResume from "components/courses/viewcourse/course-resume/CourseResume";
import AddLecture from "components/courses/add-new-course/steps/AddLecture";
import AssessmentReview from "components/courses/assessment-review";
import OrganizationDetails from "components/organisation/organizationDetails";
import ViewOrganizationDetails from "components/organisation/viewOrganizationDetails";

import CourseSingle2 from "components/courses/viewcourse/course-resume/about-course";

// // Student New Dashboard Pages for Quiz ( v2.0.0)
// import StudentQuiz from 'components/marketing/student/Quiz';
import StudentQuizStart from "components/courses/viewcourse/course-resume/Quiz/QuizStart";

// import StudentQuizAttempt from 'components/marketing/student/QuizAttempt';
import StudentQuizResult from "components/courses/viewcourse/course-resume/Quiz/QuizResult";
import StudentQuizTimeout from "components/courses/viewcourse/course-resume/Quiz/QuizTimeOut";
import AddUserGroup from "components/users/add-user-group";
import UserGroups from "components/users/view-user-groups";
import Users from "components/users/view-users";
import UserLandingPage from "components/dashboard/user-landing-page/UserLandingPage";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import LiveClassContainer from "containers/liveclass/LiveClassContainer";
import VideoConference from "containers/liveclass/VideoConference";
import WhiteboardContainer from "containers/whiteboard/WhiteboardContainer";
import AuthHome from "components/authentication/AuthHome";
import ContentGeneration from "components/content-generation/content-generation";
import ContentGenerationDashboard from "components/content-generation/content-generation-dashboard";
import { useCookies } from "react-cookie";
import VideoGeneration from "components/content-generation/video-generation";
import PPTGeneration from "components/content-generation/ppt-generation";
import ResourceGeneration from "components/content-generation/resource-upload";
import QAGeneration from "components/content-generation/qna-generation";
import NotesUpload from "components/content-generation/notes-upload";
import AcademicYears from "components/academicYears/AcademicYears";
import EventTypes from "components/eventTypes/EventTypes";
import ClassSection from "components/classSection/ClassSection";
import CalendarEvents from "components/calendarEvents/CalendarEvents";
import TimeTable from "components/timeTable/TimeTable";
import ManageTimeTable from "components/timeTable/ManageTimeTable";
import Attendance from "components/attendance/Attendance";
import AttendanceHistory from "components/attendance/AttendanceHistory";

const ProtectedRoute = () => {
  const isAuthenticated = useIsAuthenticated();
  const [cookies] = useCookies();
  const { accounts } = useMsal();
  return accounts?.length === 1 || cookies?.userId ? (
    <DashboardIndex />
  ) : (
    <Navigate to="/" />
  );
};

const AllRoutes = () => {
  const location = useLocation();
  const refreshKey = location.state?.refreshKey || "default";

  return (
    <Routes>
      {/* Routes with AuthLayout */}
      <Route element={<AuthLayout />}>
        <Route path="/" element={<AuthHome />} />
      </Route>
      {/* Routes (DASHBOARD ROUTERS) with DashboardIndex */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard/overview" element={<UserLandingPage key={refreshKey} />} />
        <Route path="/dashboard/analytics" element={<Analytics />} />
        <Route path="/courses/" element={<AllCourses />} />
        {/* <Route path="/users/" element={<Users />} />   */}
        <Route path="/add-new-user/" element={<AddUser />} />
        <Route path="/user-groups" element={<UserGroups />} />
        <Route path="/user-groups/add" element={<AddUserGroup />} />
        <Route path="/user-groups/:id" element={<Users />} />

        <Route path="/organization/" element={<AllOrg />} />
        <Route path="/about-organization/" element={<ConfigOrg />} />
        <Route path="/orgsingle/:id" element={<OrgSingle />} />
        <Route path="/add-new-org/" element={<AddOrg />} />
        <Route path="/add-new-course/" element={<Addnewcoures />} />
        <Route
          path="/view-course/:courseId/:sectionId/:contentId"
          element={<CourseResume />}
        />
        <Route path="/view-course/:courseId" element={<CourseResume />} />

        <Route path="/add-org-coordinator/" element={<AddNewCoordinator />} />
        <Route path="/add-lecture" element={<AddLecture />} />
        <Route path="/assessment-review" element={<AssessmentReview />} />
        <Route path="/organization-details" element={<OrganizationDetails />} />
        <Route
          path="/view-organization-details"
          element={<ViewOrganizationDetails />}
        />
        <Route path="/live-class" element={<LiveClassContainer />} />
        <Route path="/room/:roomId" element={<VideoConference />} />
        <Route path="/whiteboard" element={<WhiteboardContainer />} />

        <Route path="/content-generation/" element={<ContentGeneration />} />
        <Route
          path="/content-generation-dashboard/"
          element={<ContentGenerationDashboard />}
        />
        <Route
          path="/video-generation/:videoId?"
          element={<VideoGeneration />}
        />
        <Route path="/ppt-generation/:pptId?" element={<PPTGeneration />} />
        <Route
          path="/resource-generation/:resourceId?"
          element={<ResourceGeneration />}
        />
        <Route path="/notes-upload/:noteId?" element={<NotesUpload />} />
        <Route path="/qa-generation/:qnaId?" element={<QAGeneration />} />
        <Route
          path="/marketing/student/quiz/result/"
          element={<StudentQuizResult />}
        />
        <Route
          path="/marketing/student/quiz/timeout/"
          element={<StudentQuizTimeout />}
        />
        <Route path="/about-course/:courseId" element={<CourseSingle2 />} />
        <Route path="/academic-years" element={<AcademicYears />} />
        <Route path="/event-types" element={<EventTypes />} />
        <Route path="/sections" element={<ClassSection />} />
        <Route path="/calendar" element={<CalendarEvents />} />
        <Route path="/timetable" element={<TimeTable />} />
        <Route path="/manage-timetable" element={<ManageTimeTable />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/attendance-history" element={<AttendanceHistory />} />
      </Route>

      <Route
        path="*"
        element={<Navigate to="/marketing/specialty/404-error/" replace />}
      />
    </Routes>
  );
};

export default AllRoutes;
